//@ts-check
import AppStore from "Stores/AppStore";

/**
 * @returns {import("Stores/LeftPanel/MainItems").LeftPanelItemState[]}
 */
export const DeviceTracesItems = () => {
    let { pageTitle, params } = AppStore.lastPageInfo;
    let returnParams = '';

    // @ts-ignore
    if (pageTitle === 'users' && params != null && params.page != null)
        // @ts-ignore
        returnParams = `?page=${params.page}`;

    return [
        {
            id: 'back',
            linkTo: `${window.SmrLocation}/users${returnParams}`,
            title: 'Назад',
            icon: 'us-back-menu',
            isDisabled: false,
            isError: false,
            isSelected: true,
            onClick: () => { },
            isAvailable: true
        }
    ]
}